// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9412 ? "37a763b4" : chunkId) + "." + {"1060":"1f8954f404b7823b","4186":"018699516e4215e5","5846":"33c7f979acd48700","6565":"48237669d86a2796","9007":"620af2b963e77928","9412":"588830ea8e5d91b2"}[chunkId] + ".js";
};